var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 24.7535,
    cy: 25.2608,
    r: 24.2535,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.62 25.2973C21.06 28.1273 23.38 30.4373 26.21 31.8873L28.41 29.6873C28.68 29.4173 29.08 29.3273 29.43 29.4473C30.55 29.8173 31.76 30.0173 33 30.0173C33.55 30.0173 34 30.4673 34 31.0173V34.5073C34 35.0573 33.55 35.5073 33 35.5073C23.61 35.5073 16 27.8973 16 18.5073C16 17.9573 16.45 17.5073 17 17.5073H20.5C21.05 17.5073 21.5 17.9573 21.5 18.5073C21.5 19.7573 21.7 20.9573 22.07 22.0773C22.18 22.4273 22.1 22.8173 21.82 23.0973L19.62 25.2973Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPhoneIcon);
export default __webpack_public_path__ + "static/media/contactPhoneIcon.2c7755b5b00666e154c5d50a74bd474b.svg";
export { ForwardRef as ReactComponent };